import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Skeleton } from "./ui/skeleton";
import { Separator } from "./ui/separator";
import { formattedDateWithOrdinal } from "@/lib/helper";
import type { ReactNode } from "react";

type CustomCardProps = {
  title: string;
  mainTitle: ReactNode;
  text?: string;
  isLoading?: boolean;
  date?: string | Date;
};

const CustomCard = ({
  title,
  mainTitle,
  text,
  isLoading,
  date,
}: CustomCardProps) => {
  return (
    <Card className="flex flex-col gap-4 p-6  justify-between rounded-xl border-[1px] border-off-white ">
      <CardHeader className="flex-row items-center justify-between p-0 space-y-0">
        <CardTitle className="text-sm font-medium text-primary-4 capitalize ">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        {isLoading ? (
          <Skeleton className="w-full h-4" />
        ) : (
          <p className="text-2xl font-medium text-primary-1 ">{mainTitle}</p>
        )}
      </CardContent>
      {title.includes("rate") || text ? (
        <div>
          <Separator orientation="horizontal" className="h-[1px] bg-border" />

          <CardFooter className="flex-row gap-4 p-0 pt-4 text-gray-60 ">
            {title.includes("rate") ? (
              <span className="text-xs text-gray-60 h-6 flex justify-center items-center ">
                Average USDT to NGN Rate
              </span>
            ) : (
              <>
                <span className="flex justify-center items-center rounded-[24px] bg-green-0 h-6 w-[45px] text-green-2 text-xs font-medium ">
                  +{text}%
                </span>
                <span className="text-xs ">
                  from previous week ending{" "}
                  {date
                    ? formattedDateWithOrdinal(date)
                    : formattedDateWithOrdinal(new Date())}
                </span>
              </>
            )}
          </CardFooter>
        </div>
      ) : null}
    </Card>
  );
};

export default CustomCard;
